import { Stack } from '@mui/material';
import React from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useTheme } from '@emotion/react';
import pdfIcon from '../assets/images/pdfIcon.png';
import xlsxIcon from '../assets/images/xlsx_icon.svg.png'

export default function DocumentViewer({ data }) {
  const theme = useTheme();

  const handleDownload = async () => {
    try {
      const response = await fetch(data?.attachment);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const name = data?.attachment?.split('/').pop();
      link.download = `${name}`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  return (
    <Stack direction={'row'} flexWrap={'wrap'} className='mr-4 cursor-pointer'>
      <Stack>
         {data?.attachment?.split('.')?.pop() === 'pdf' ? (
              <img
                src={pdfIcon}
                alt={'image'}
                style={{ width: '64px', height: '64px' }}
              />
            ) :
            (data?.attachment?.split('.')?.pop() === 'xlsx' || data?.attachment?.split('.')?.pop() === 'xls') ? (
              <img
                src={xlsxIcon}
                alt={'image'}
                style={{ width: '64px', height: '64px' }}
              />
            )
            :
            (
              <img
                src={data?.attachment}
                alt={'image'}
                style={{ width: '64px', height: '64px' }}
              />
            )}
      </Stack>
      <Stack
        alignItems={'flex-end'}
        justifyContent={'flex-end'}
        sx={{color: '#8993AC'}}
      >
        <SaveAltIcon style={{ marginLeft: '16px' }} onClick={() => handleDownload()}/>
      </Stack>
    </Stack>
  );
}
